import 'bootstrap/dist/css/bootstrap.min.css';


import AppRoutes from './Vinod Website/Pages/Routes';

function App() {
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
